const floatingNavigationItems = document.querySelectorAll('.floatingNavigation ul li')

function handleMouseEnterLeaveTouchStart (e) {
  if (e.type === 'touchstart') {
    this.removeEventListener('mouseenter', handleMouseEnterLeaveTouchStart)
    this.removeEventListener('mouseleave', handleMouseEnterLeaveTouchStart)
  }

  floatingNavigationItems.forEach(item => {
    if (item !== this) {
      item.classList.remove('hover')
    }
  })

  this.classList.toggle('hover')
}

floatingNavigationItems.forEach(item => {
  item.addEventListener('mouseenter', handleMouseEnterLeaveTouchStart)
  item.addEventListener('mouseleave', handleMouseEnterLeaveTouchStart)
  item.addEventListener('touchstart', handleMouseEnterLeaveTouchStart)
})
